import { GlobalButton } from './GlobalButton';

export const NextButton = (props: any) => {
	return <GlobalButton size="medium" {...props}></GlobalButton>;
};
